import { IEntityInfoView } from '@components/widgets/entity-info/EntityInfoFields';
import EntityInfoWidget from '@components/widgets/entity-info/EntityInfoWidget';
import { IAbstractRecord } from '@models';
import React from 'react';
import { EnhancedDisplayType } from '@components/widgets/dynamic-display/EnhancedDisplay';

interface ILeftPanel {
  data: IAbstractRecord;
  title: string;
}

const LeftPanel: React.FC<ILeftPanel> = ({ data, title }) => {
  const entityView: IEntityInfoView = {
    name: 'section1',
    title: 'Business User Details',
    iconUrl: '',
    sections: [
      {
        name: 'businessUserDetailsSection1',
        title: '',
        properties: {
          name: {
            value: data.name,
            multiline: false,
            name: 'name',
            title: 'Full Name',
          },
          businessUserCode: {
            value: data.businessUserCode,
            multiline: false,
            name: 'businessUserCode',
            title: 'Business User Code',
          },
          dateOfBirth: {
            value: data.dateOfBirth,
            multiline: false,
            name: 'dateOfBirth',
            title: 'Date Of Birth',
            type: EnhancedDisplayType.Date,
          },
          email: {
            value: data.email,
            multiline: false,
            name: 'email',
            title: 'Email',
          },
          phoneType: {
            value: data.phoneType,
            multiline: false,
            name: 'phoneType',
            title: 'Phone Type',
          },
          phoneNumber: {
            value: data.phoneNumber,
            multiline: false,
            name: 'phoneNumber',
            title: 'Phone Number',
          },
          taxable: {
            value: data.taxable,
            multiline: false,
            name: 'taxable',
            title: 'Taxable',
          },
          isAdmin: {
            value: data.isAdmin,
            multiline: false,
            name: 'isAdmin',
            title: 'Admin Role',
          },
        },
      },
      {
        name: 'businessUserDetailsSection2',
        title: '',
        properties: {
          createdBy: {
            value: data.createdBy,
            multiline: false,
            name: 'createdBy',
            title: 'Created By',
          },
          createdOn: {
            value: data.createdOn,
            multiline: false,
            name: 'createdOn',
            title: 'Created On',
            type: EnhancedDisplayType.DateTime,
          },
          modifiedBy: {
            value: data.modifiedBy,
            multiline: false,
            name: 'modifiedBy',
            title: 'Modified By',
          },
          modifiedOn: {
            value: data.modifiedOn,
            multiline: false,
            name: 'modifiedOn',
            title: 'Modified On',
            type: EnhancedDisplayType.DateTime,
          },
        },
      },
    ],
    socialMedia: {
      facebook: '',
      linkedIn: '',
      twitter: '',
    },
  };

  return (
    <EntityInfoWidget
      background="rgb(193, 0, 0)"
      classification={{ classifications: {}, value: '' }}
      progress={100}
      supportsClassification
      supportsProgressBar
      title={title}
      view={entityView}
    />
  );
};

export default LeftPanel;
